// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RIb_-","textarea":"styles_textarea__2Y9Ps"};